import { Icon, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { MdDescription } from 'react-icons/md';

interface LabDocumentEmptyStateProps {
  message?: string;
}

export const LabDocumentEmptyState: FC<LabDocumentEmptyStateProps> = ({
  message = 'No lab documents found',
}) => {
  return (
    <VStack spacing={2} py={10} px={4} align="center" width="100%">
      <Icon as={MdDescription} boxSize={8} color="text.subtle" />
      <Text fontSize="sm" color="text.muted" textAlign="center">
        {message}
      </Text>
    </VStack>
  );
};

LabDocumentEmptyState.displayName = 'LabDocumentEmptyState';
